import {
  OreButton,
  OreCardActions,
  OreCardContainer,
  OreCardWrapper,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { createApiContractRepository } from '@/Contract/infrastructure'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { useContractDataController } from '@/Contract/ui/hooks'
import {
  ContractBillingDataFormAddress,
  ContractBillingDataFormCommon,
} from '@/Contract/ui/molecules'
import { formTranslation } from '@/Shared/ui/sharedTranslation'
import { useUserData } from '@/User/ui/context'

export const ContractBillingDataForm = (props:{show: boolean}): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()

  const { form, save } = useContractDataController(
    createApiContractRepository(),
    merchant.id,
  )

  return (
    <FormProvider {...form}>
      <form>
        <OreCardContainer>
          <OreCardWrapper>
            <OreStack space="2xlarge" placeContent="stretch">
              <ContractBillingDataFormCommon />
              <ContractBillingDataFormAddress show={props.show} />
              <OreText>{t(formTranslation.common.requiredFields)}</OreText>
            </OreStack>
          </OreCardWrapper>
          <OreCardActions>
            <OreStack direction="row" placeContent="end" space="medium">
              <OreButton
                size="small"
                disabled={!form.formState.isDirty}
                onClick={() => {
                  form.reset()
                }}
                category="secondary"
              >
                {t(contractTranslation.billingData.form.cancelLabel)}
              </OreButton>
              <OreButton
                disabled={!form.formState.isDirty}
                type="submit"
                onClick={form.handleSubmit(save)}
                size="small"
                category="primary"
              >
                {t(contractTranslation.billingData.form.editLabel)}
              </OreButton>
            </OreStack>
          </OreCardActions>
        </OreCardContainer>
      </form>
    </FormProvider>
  )
}
